import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AuthState } from "./auth.model";

const selectState = createFeatureSelector<AuthState>('authState');

export const selectAuthState = createSelector(
  selectState,
  (state: AuthState) => state
)